import { render, staticRenderFns } from "./TemplatesCollectionView.vue?vue&type=template&id=ed7d4dac&"
import script from "./TemplatesCollectionView.vue?vue&type=script&lang=ts&"
export * from "./TemplatesCollectionView.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesCollectionView.vue?vue&type=style&index=0&id=ed7d4dac&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports